module.exports = __webpack_public_path__ + "static/media/aboutLogo.512b26fb.png";